// src/features/auth/authSlice.ts
import { createSlice } from "@reduxjs/toolkit";

export type Role = "admin" | "client";
type AuthState = {
  token: string | null;
  role: Role | null;
};

const initialState: AuthState = {
  token: localStorage.getItem("token"),
  role: (localStorage.getItem("role") as Role | null) || null,
};

const slice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setAuth(state, action) {
      const { token, role } = action.payload as { token: string; role: Role };
      state.token = token;
      state.role  = role;
      localStorage.setItem("token", token);
      localStorage.setItem("role", role);
    },
    logout(state) {
      state.token = null;
      state.role = null;
      localStorage.removeItem("token");
      localStorage.removeItem("role");
    },
  },
});

export const { setAuth, logout } = slice.actions;
export default slice.reducer;
